<template>
  <div>
    <!-- toasts message -->
                <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->
    <v-progress-circular v-if="Loader" :size="70" :width="7" color="teal" indeterminate></v-progress-circular>

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-select
                  label="Training Head Name"
                  item-text="name"
                  item-value="id"
                  :items="costHead"
                  v-model="formSchema.training_cost_head_id"
                  :rules="[v => !!v || 'Training Head Name is required']"
                ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Exchange Rate"
                v-model="formSchema.exchange_rate"
                :rules="[rules.decimalOnly]"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                label="USD"
                v-model="formSchema.usd_amount"
                :rules="[rules.decimalOnly]"
                @input="setBDTRate($event)"
              >
              </v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="BDT"
                v-model="formSchema.bdt_amount"
                :rules="[rules.decimalOnly]"
                @input="setUSDRate($event)"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="previous">
        <v-icon>arrow_back_ios</v-icon>Previous
      </v-btn>
      <v-btn color="primary" @click="submitOperationActivities">
        {{addUpdateBtn}}
        <v-icon>save</v-icon>
      </v-btn>
      <v-btn color="error" @click="reset">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn color="success" :to="`/training/training-info`">
        GO TO LIST
        <v-icon>home</v-icon>
      </v-btn>
       <!-- <v-btn color="warning" @click="nextStep">
         Next
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn> -->
    </v-card-actions>
    
     <v-card class="mb-3 mt-3 table-responsive" color="lighten-1">
      <v-data-table
      class="elevation-4"
      :headers="headers"
      :items="items"
    >
     <template slot="items" slot-scope="props">
			            <td class="text-xs-left">{{ (props.index)+1 }}</td>
			            <!-- <td class="text-xs-left">{{ props.item.training_id }}</td> -->
			            <td class="text-xs-left">{{ props.item.name }}</td>
			            <td class="text-xs-left">{{ props.item.exchange_rate }}</td>
			            <td class="text-xs-left">{{ props.item.usd_amount | currency }}</td>
			            <td class="text-xs-left">{{ props.item.bdt_amount | currency}}</td>
			            
			            <td class="justify-center layout px-0">
			                <v-btn icon class="mx-0"  @click="editItem(props.index, props.item)">
			                    <v-icon color="teal">edit</v-icon>
			                </v-btn>
			                <v-btn icon class="mx-0"  @click="deleteItem(props.index, props.item.id)">
			                    <v-icon color="pink">delete</v-icon>
			                </v-btn>
			                
			            </td>

			        </template> 
		 

		        <template slot="no-data">
		            <!-- <v-btn color="primary" @click="getDataFromApi()">Reset</v-btn> -->
		        </template>
    </v-data-table>
      
    </v-card>

    
  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
let utilities = require("../../../../utilities/utilities");
export default {
  props:['get_training_id'],

  data() {
    return {
      headers: [
      {
        text:'SL'
      },
      // {
      //   text: "Training ID",
      //   align: "left",
      //   sortable: true,
      //   value: "training_id"
      // },
      { text: "Head Code", align: "left", sortable: true, value: "name" },
      { text: "Exchange Rate", align: "left", sortable: false, value: "exchange_rate" },
      { text: "USD", align: "left", sortable: true, value: "usd_amount" },
      { text: "BDT",sortable: true, value: "bdt_amount" },
     
      { text: "Action", value: "", align:"center" }
    ],
      valid: true,
      e1: 0,
      operation_act_id: sessionStorage.getItem("operation_act_id"),

      rules: {
        decimalOnly: value => {
          const pattern = /^\d+(\.\d)?\d*$/;
          return pattern.test(value) || "Not a valied number";
        }
      },
      Loader: false,
      delete_id: "",
      row_index: "",
      dialog2: false,
      snackbar: false,
      color: "success",
      mode: "",
      timeout: 3000,
      left: "left",
      message: "",

      projectComponentList: utilities.getProjectComponentList(),

      SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
      formSchema: {
        id: 0,
        training_id: sessionStorage.getItem("training_info"),
        training_cost_head_id:"",
        usd_amount: "",
        bdt_amount: "",
        exchange_rate:""
      },

      dataList: [],
      training:[],
      costHead:[],
      items:[]
    };
  },

 created() { 
   
    this.loadData();
  
  },
  watch: {
     get_training_id(){
         this.formSchema.training_id = this.get_training_id
    }
  },
  methods: {

    loadData() {
        commonService.getAllDataById(this.formSchema.training_id,"cost_info")
        .then(res => {
          if (res.data.length > 0) {
            this.items = res.data;            
          }
        });

    },

    submitOperationActivities() {
      if (this.$refs.form.validate()) {        
          this.submitForm();
      };
    },

    submitForm() {
     let root = this;
      let formSchema = this.formSchema
      this.Loader = true;
       if ( formSchema.id > 0 )
          {            
              commonService.updateFormData(formSchema, 'cost_info').then(res => {							
							if(res.status == 1){
                 this.SnackbarVal.color = 'success';
                 this.SnackbarVal.message = res.message;
                 this.SnackbarVal.snackbar = true;
                 this.$refs.form.reset();
                 this.formSchema.id = 0
                 this.loadData()
							}
						});
            
          }
          else
          {            
            commonService.insertFormData(formSchema, 'cost_info').then(res => {	
             				
							if(res.status == 1){
                 this.SnackbarVal.color = 'success';
                 this.SnackbarVal.message = res.message;
                 this.SnackbarVal.snackbar = true;
                 this.$refs.form.reset();
                 this.loadData()
							}
						});
            
          }
        this.Loader = false
    },

    setUSDRate(e){
       if( this.formSchema.exchange_rate > 0 && this.formSchema.bdt_amount > 0){
         let res = parseFloat(e) / parseFloat(this.formSchema.exchange_rate)
         this.formSchema.usd_amount = res.toFixed(3)
       }else{
         this.formSchema.usd_amount = ''
       }
    },
    setBDTRate(e){
        if( this.formSchema.exchange_rate > 0 && this.formSchema.usd_amount > 0){
         let res = parseFloat(e) * parseFloat(this.formSchema.exchange_rate)
         this.formSchema.bdt_amount = res.toFixed(3)
       }else{
         this.formSchema.bdt_amount = ''
       }
    },
    formatAmount(amount) {
      
    },

    previous() {
      // this.$refs.form.reset();
      this.$emit("emitForm4", 2);
    },

    editItem(index, item) {
      this.row_index = index;
      this.formSchema = item;
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "cost_info").then(res => {
        if (res.status == 1) {
          this.items.splice(row_index, 1);
        }
        this.SnackbarVal.color = 'success';
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close: function() {
      let formSchema = this.formSchema;
      Object.keys(formSchema).forEach(function(key) {
        formSchema[key] = "";
      });
      this.$refs.form.reset();
    },
    reset(){
        if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
      }
    },
    goback(){
        sessionStorage.removeItem('training_info')
        
      return this.$router.push("`/training/training-info-form`")
    }
  },
  computed:{
     getTrainingData(){
       commonService.getAllData('training_info').then(res => {  
                    this.training = res.data;
                    this.loading = false;
              });   
     },
    //  training_cost_head
    getCostHeadData(){
       commonService.getAllData('get_training_cost_head').then(res => {  
                    this.costHead = res.data;
                    this.loading = false;
              });   
     },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },
    setBDT(){
      console.log('afaj')
    }
  },
  
  mounted(){
    this.getTrainingData
    this.getCostHeadData
  }
};
</script>




// WEBPACK FOOTER //
// src/components/training/training_information/step_forms/costInformation.vue